import formatNumber from '@framework/data-helpers/formatters/formatNumber';

interface IPercentCellProps {
  value: string | number | null | undefined,
  decimals?: number,
}

const NUMERIC_PATTERN = /^-?\d+(\.\d+)?$/;

const PercentCell = ({ value, decimals = 2 }: IPercentCellProps) => {
  if (value === null || value === undefined || value === '') {
    return (<>-</>);
  }

  const stringValue = String(value).trim();

  if (NUMERIC_PATTERN.test(stringValue)) {
    const numeric = parseFloat(stringValue);
    return (<>{ `${ formatNumber(numeric, { decimals }) }%` }</>);
  }

  return (<>{ stringValue }</>);
};

export default PercentCell;
